import { createThemedComponent } from '../util/createThemedComponent';
export var IconButton = createThemedComponent(['variant', 'size'], {
    as: 'button',
    variant: 'secondary',
    size: 'md',
    sx: {
        cursor: 'pointer',
        appearance: 'none',
        fontSize: 2,
        outline: 'none',
    },
    themeKey: 'iconButtons',
    type: 'button',
});
//# sourceMappingURL=IconButton.js.map